import { ICustomLeagueDictionaryApi, ICustomLeagueFilter } from '@/types';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { CustomLeagueDictionaryItem } from '@/models/dictionary/customLeague';

export const useCustomLeagueDictionary = defineStore('customLeagueDictionary', () => {
    const items = shallowRef<CustomLeagueDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(items);

    // actions
    function setData(data: ICustomLeagueDictionaryApi[]) {
        console.time('set-customLeague-dictionary');
        items.value = data.map((item) => new CustomLeagueDictionaryItem(item));
        console.timeEnd('set-customLeague-dictionary');
    }

    function filterBy(filters: ICustomLeagueFilter) {
        return items.value.filter((item: CustomLeagueDictionaryItem) => {
            return (
                (filters.countryId !== null && filters.countryId !== undefined ? item.countryId === filters.countryId : true) &&
                (filters.gender !== null && filters.gender !== undefined ? item.gender === filters.gender : true) &&
                (filters.categoryId !== null && filters.categoryId !== undefined ? item.categoryId === filters.categoryId : true) &&
                (filters.limitsCategoryId !== null && filters.limitsCategoryId !== undefined ? item.limitsCategoryId === filters.limitsCategoryId : true) &&
                (filters.ageCategoryId !== null && filters.ageCategoryId !== undefined ? item.ageCategoryId === filters.ageCategoryId : true)
            );
        });
    }

    return {
        items,
        itemById,
        nameById,
        setData,
        filterBy,
    };
});
